<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    newTitle="Nova Unidade"
    newCreateButtonLabel="Adicionar Unidade"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :inlineAddButton="inlineAddButton"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
      />
    </template>
    
    <!-- documentadao de slot nested -->
    <!-- https://stackoverflow.com/questions/53430731/vuejs-nested-slots-how-to-pass-slot-to-grandchild -->
    <template v-slot:open_button="dialog">
      <slot name="open_button" v-bind="dialog"></slot>
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_UNIT_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.adminContext.unit;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(unit) {
      // console.log("UNIT", unit, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(unit, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_UNIT_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(unit, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createUnit.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createUnit.unit);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_UNIT_QUERY = gql `
  {
    adminContext{
      unit {
        id
        name
        description
        unitId
        unit {
          name
        }
        validations
      }
    }
  }
`;

const CREATE_UNIT_MUTATION = gql `
  mutation($input: UnitCreateInputObject!) {
    createUnit(input: $input) {
      unit {
        id
        name
        description                      
        unitId
        unit {
          name
        }
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
